/* eslint-disable max-len */
import { am5, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import { getColor } from '../../../../helpers';

export const createSeries = ({
  root,
  chart,
  data,
  xAxisField,
  yAxisField,
  xAxis,
  yAxis,
  showBucketOnTooltip,
  showError,
  percent,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.ErrorLinearData;
  xAxisField: string;
  yAxisField: string;
  xAxis: am5xy.ValueAxis<am5xy.AxisRenderer>;
  yAxis: am5xy.ValueAxis<am5xy.AxisRenderer>;
  showBucketOnTooltip: boolean;
  percent: boolean;
  showError: boolean;
}) => {
  const createSingleSeries = (field: string, color: am5.Color) => {
    const series = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: field,
        stroke: color,
        fill: color,
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: yAxisField,
        valueXField: xAxisField,
      })
    );

    const tooltip = am5.Tooltip.new(root, {
      labelText: showBucketOnTooltip
        ? // eslint-disable-next-line max-len
          `{name} \nvalue: {valueY.formatNumber('#.##')}${percent ? '%' : ''} \nerror: {error.formatNumber('#.##')}${percent ? '%' : ''}`
        : // eslint-disable-next-line max-len
          `value: {valueY.formatNumber('#.##')}${percent ? '%' : ''} \nerror: {error.formatNumber('#.##')}${percent ? '%' : ''}`,
    });

    tooltip.label.setAll({
      fontSize: 11,
    });

    series.set('tooltip', tooltip);

    if (showError) {
      series.bullets.push(function () {
        const graphics = am5.Graphics.new(root, {
          strokeWidth: 2,
          stroke: series.get('stroke'),
          draw: function (display, target) {
            const dataItem = target.dataItem;

            const error = (dataItem.dataContext as any).error;

            const yPosition0 = yAxis.valueToPosition(0);
            const yPosition1 = yAxis.valueToPosition(error);

            const height =
              (yAxis.get('renderer').positionToCoordinate(yPosition1) -
                yAxis.get('renderer').positionToCoordinate(yPosition0)) /
              2;

            display.moveTo(0, -height);
            display.lineTo(0, height);

            display.moveTo(-10, -height);
            display.lineTo(10, -height);

            display.moveTo(-10, height);
            display.lineTo(10, height);
          },
        });

        return am5.Bullet.new(root, {
          dynamic: true,
          sprite: graphics,
        });
      });

      series.bullets.push(function () {
        const graphics = am5.Circle.new(root, {
          strokeWidth: 2,
          radius: 3,
          stroke: series.get('stroke'),
          fill: root.interfaceColors.get('background'),
        });
        return am5.Bullet.new(root, {
          sprite: graphics,
        });
      });
    }

    return series;
  };

  Object.keys(data).forEach((key, index) => {
    const seriesObj = createSingleSeries(key, am5.color(getColor(index)));
    seriesObj.appear(1000);
    seriesObj.data.setAll(data[key]);
    xAxis.data.setAll(data[key]);
  });
};
